<script>
import { patientsPortalStore } from './patientsPortalStore';
import EnumService from '@/services/enum.service';
import Utils from '@/common/utils';
import DBFunctions from '@/common/DBFunctions.js';
import PatientPortalsService from '@/services/patientportals.service';
import MessageTemplateSetupsService from '@/services/messagetemplatesetups.service';
import GlobalService from '@/services/global.service.js';

export default {
    name: 'PatientsPortalBase',
    mixins: [DBFunctions],
    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                btnvisible: false,
                ItemsList: [],
                favButtonAtion: false
            },
            RightMenuList: JSON.parse(JSON.stringify(EnumService.PatientsPortalDashboardItems)),
            selectedItems: [],
            PatientTitle: {
                programName: '',
                fullName: '',
                admitDate: '',
                dischargeDate: '',
                dob: ''
            },
            textEditorVisible: false,
            textEditorValue: '',
            changePasswordVisible: false,
            createLoginVisible: false,
            changeUserNameVisible: false,
            notifyEmailTemplateList: [],
            notifyTextTemplateList: [],
            mailOptionSetups: [],
            notifyVisible: false,
            notifyType: ''
        };
    },
    computed: {
        patientsPortalStore() {
            return patientsPortalStore;
        },
        selectedPatientCodeList() {
            return this.selectedItems.map(x => x.patientCode);
        },
        /*selectedPatientCode() {
            if (this.selectedPatientCodeList.length === 1) {
                return this.selectedPatientCodeList[0];
            }

            return null;
        },*/
        selectedUserName() {
            if (this.selectedItems.length === 1) {
                return this.selectedItems[0].userName || '';
            }

            return '';
        },
        selectedEmail() {
            if (this.selectedItems.length === 1) {
                return this.selectedItems[0].email || '';
            }

            return '';
        },
        selectedFullName() {
            if (this.selectedItems.length === 1) {
                return this.selectedItems[0].lastName + ', ' + this.selectedItems[0].firstName;
            }

            return '';
        },
        patientCodeFirstOrDefault() {
            if (this.selectedItems.length === 1) {
                return this.selectedItems[0].patientCode;
            }

            return '';
        }
    },
    watch: {
        'patientsPortalStore.updatedAt'() {
            if (!patientsPortalStore.executeAction) {
                return;
            }

            this.handlerClick(patientsPortalStore.executeAction);
        }
    },
    methods: {
        closeTextEditorHandler() {
            this.textEditorVisible = false;
        },

        handlerClick(action) {
            switch (action) {
                case 'CreateCredentials':
                    this.createCredentials();
                    break;
                /*
                case 'CreateAuthLogins':
                    this.createAuthLogins();
                    break;
                */
                case 'ChangeUsername':
                    this.changeUserName();
                    break;
                /*
                case 'CreateLogin':
                    this.createLogin();
                    break;
                */
                case 'ChangePassword':
                    this.changePassword();
                    break;
                case 'PatientContacts':
                    this.executeView('patients-portal-contacts', false, {
                        id: this.patientCodeFirstOrDefault
                    });
                    break;
                case 'PatientClaims':
                    this.executeView('patients-portal-claims', false, {
                        id: this.patientCodeFirstOrDefault
                    });
                    break;
                case 'ChangePatInfo': {
                    const changeInfoPatientCode =
                        this.patientCodeFirstOrDefault || this.$route.params.id;
                    this.executeView(
                        'patients-portal-change-info',
                        true,
                        changeInfoPatientCode ? { id: changeInfoPatientCode } : {}
                    );
                    break;
                }
                case 'Messages': {
                    const messagesPatientCode =
                        this.patientCodeFirstOrDefault || this.$route.params.id;
                    this.executeView(
                        'patients-portal-message',
                        true,
                        messagesPatientCode ? { id: messagesPatientCode } : {}
                    );
                    break;
                }
                case 'EmailToPatient':
                    this.showNotify('email');
                    break;
                case 'TextToPatient':
                    this.showNotify('text');
                    break;
                case 'PatientForms':
                    this.executeView('patients-portal-form', false, {
                        id: this.patientCodeFirstOrDefault
                    });
                    break;
                case 'PatientList':
                    this.executeView('patients-portal', true);
                    break;
                case 'Summary':
                    if (this.selectedItems.length === 1) {
                        patientsPortalStore.selectedItem = this.selectedItems[0];
                    }
                    this.$router
                        .push({
                            name: 'patients-portal-summary',
                            params: { id: this.patientCodeFirstOrDefault || this.$route.params.id }
                        })
                        .catch(() => {});
                    break;
                case 'PatientInfo':
                    if (this.selectedItems.length === 1) {
                        patientsPortalStore.selectedItem = this.selectedItems[0];
                    }
                    this.executeView('patients-portal-info', false, {
                        id: this.patientCodeFirstOrDefault
                    });
                    break;
                default:
                    break;
            }
        },

        isNotify(type) {
            let buttonEnabled = false;
            switch (type) {
                case 'email':
                    {
                        const allHasEmail = this.selectedItems.every(
                            x => !Utils.isNullOrEmptyString(x.email)
                        );

                        buttonEnabled =
                            this.selectedItems.length !== 0 &&
                            allHasEmail &&
                            this.notifyEmailTemplateList.length !== 0 &&
                            this.mailOptionSetups.length !== 0;
                    }
                    break;
                case 'text':
                    {
                        const allHasCellPhone = this.selectedItems.every(
                            x => !Utils.isNullOrEmptyString(x.cellPhone)
                        );

                        buttonEnabled =
                            this.selectedItems.length !== 0 &&
                            allHasCellPhone &&
                            this.notifyTextTemplateList.length !== 0 &&
                            this.mailOptionSetups.length !== 0;
                    }
                    break;
            }

            return buttonEnabled;
        },

        showNotify(type) {
            this.notifyType = type;
            this.notifyVisible = true;
        },

        async getOptions() {
            let params = {
                SendTo: 'PATIENT',
                ShowIn: 'PATIENTPORTAL'
            };

            await MessageTemplateSetupsService.getAll(params)
                .then(response => {
                    if (response.status == '200') {
                        this.notifyEmailTemplateList = response.data.filter(
                            message => message.notificationType.toLowerCase() === 'email'
                        );
                        this.notifyTextTemplateList = response.data.filter(
                            message => message.notificationType.toLowerCase() === 'text'
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getMailOptionSetups() {
            await GlobalService.getMailOptionSetups()
                .then(response => {
                    if (response.status == '200') {
                        this.mailOptionSetups = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        executeView(routeName, forceRoute = false, parameters = {}) {
            let patientCodeList = this.selectedItems.map(x => x.patientCode);

            if (patientCodeList.length > 0 || forceRoute) {
                /*sessionStorage.setItem(
                    'PatientPortalPatientCodeList',
                    JSON.stringify({
                        patientCodeList: patientCodeList,
                        selectedItems: this.selectedItems
                    })
                );*/
                this.$router.push({ name: routeName, params: parameters }).catch(() => {});
            }
        },

        changeUserName() {
            this.changeUserNameVisible = true;
        },

        createLogin() {
            let patientCodeList = this.selectedItems.map(x => x.patientCode);
            PatientPortalsService.verifyLogin({
                patientCode: patientCodeList.length !== 0 ? patientCodeList[0] : '',
                email: this.selectedEmail
            })
                .then(response => {
                    if (response.status == '200') {
                        if (response.data) {
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('PatientPortalDashboard.VerifyLoginMessage', {
                                    email: this.selectedEmail
                                }),
                                'success'
                            );

                            this.$nextTick(() => this.createLoginHandler(response.data));
                        } else {
                            this.createLoginVisible = true;
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        createAuthLogins() {
            PatientPortalsService.createAuthLogins({
                patientCodeList: this.selectedItems.map(x => x.patientCode)
            })
                .then(response => {
                    if (response.status == '200' && response.data) {
                        if (response.data === this.selectedItems.length) {
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('PatientPortalDashboard.AllEntrySuccessfully'),
                                'success'
                            );
                        } else {
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('PatientPortalDashboard.CreatedMessage', {
                                    created: response.data,
                                    total: this.selectedItems.length
                                }),
                                'success'
                            );
                        }

                        this.searchPatient();
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        changePassword() {
            this.changePasswordVisible = true;
        },

        afterCreateCredentials() {},

        createCredentials() {
            PatientPortalsService.createCredentials({
                patientCodeList: this.selectedItems.map(x => x.patientCode)
            })
                .then(response => {
                    if (response.status == '200' && response.data) {
                        const data = response.data;

                        if (data.errorsLog && data.errorsLog.length !== 0 && data.recordCount > 0) {
                            this.showErrorsLog(data.errorsLog);
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('PatientPortalDashboard.SomeEntryCreated'),
                                'warning'
                            );
                        } else if (data.errorsLog && data.errorsLog.length !== 0) {
                            this.showErrorsLog(data.errorsLog);
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('PatientPortalDashboard.IssuesCreating'),
                                'warning'
                            );
                        } else {
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('PatientPortalDashboard.AllEntrySuccessfully'),
                                'success'
                            );
                        }
                        this.afterCreateCredentials();
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        showErrorsLog(errors) {
            this.textEditorValue = '';
            errors.forEach(error => {
                if (error.existInPortal) {
                    this.textEditorValue += this.$t('PatientPortalDashboard.ExistInPortalError', {
                        PatientCode: error.patientCode,
                        LastName: error.lastName,
                        FirstName: error.firstName
                    });
                    this.textEditorValue += '\n';
                }

                if (!error.isValidEmail) {
                    this.textEditorValue += this.$t('PatientPortalDashboard.EmailError', {
                        PatientCode: error.patientCode,
                        LastName: error.lastName,
                        FirstName: error.firstName
                    });
                    this.textEditorValue += '\n';
                }

                if (!error.isValidDob) {
                    this.textEditorValue += this.$t('PatientPortalDashboard.DOBError', {
                        PatientCode: error.patientCode,
                        LastName: error.lastName,
                        FirstName: error.firstName
                    });
                    this.textEditorValue += '\n';
                }
            });

            this.textEditorVisible = !Utils.isNullOrEmptyString(this.textEditorValue);
        },

        getActiveElement() {
            return null;
        },

        async getPatientByCode() {
            var infoList = await this.getInfoTitle(this.selectedPatientCode);
            if (infoList.length > 0) {
                this.PatientTitle.programName = '';
                this.PatientTitle.admitDate = '';
                this.PatientTitle.dischargeDate = '';
                const { dob, firstname, lastname, age, ageFormatted } = infoList[0];

                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = firstname + ' ' + lastname;
            }
        }
    },

    async mounted() {
        this.OptionsRightMenu.visible = false;
        this.OptionsRightMenu.btnPatientsPortalDashboardVisible = true;
        this.OptionsRightMenu.ItemsList = this.RightMenuList;
        //this.OptionsRightMenu.active_el = this.getActiveElement();

        this.$emit('onMenuRightBarPatientsPortalDashboard', this.OptionsRightMenu);

        Promise.allSettled([this.getOptions(), this.getMailOptionSetups()]).then(() => {
            if (typeof this.enabledAllItems === 'function') {
                this.enabledAllItems();
            }
        });

        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.$emit('onVisibleRightMenu', this.OptionsRightMenu);
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy() {
        this.RightMenuList = JSON.parse(JSON.stringify(EnumService.PatientsPortalDashboardItems));
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    }
};
</script>
